import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { messages } from './HealthSummaryDashboardPanel.i18n';
import history from '../../history';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import { findCcdaExternalSystems } from '../../redux/modules/health-summary/external-systems-mapper';

class HealthSummaryDashboardPanel extends React.Component {
  handleButtonClick = () => {
    const {
      dispatch,
      externalSystems,
    } = this.props;

    if (!(externalSystems && externalSystems.length)) {
      dispatch(MsgBarActions.showErrorMessage('ccdaNotConfiguredError'));
    } else {
      const ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
      if (ccdaExternalSystems.length) {
        history.push('/health-summary');
      } else {
        dispatch(MsgBarActions.showErrorMessage('ccdaNotConfiguredError'));
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className="col-md-6 dashboard-module health-summary">
        <h2 className="box-title" tabIndex={0}>
          <FormattedMessage {...messages.panel.title} />
        </h2>
        <div className="panel panel-default description-box dark" data-qa-container="healthSummaryPanel">
          <div className="panel-body content-center-mid">
            <div className="content-center-inner">
              <p tabIndex={0}>
                <FormattedMessage {...messages.panel.introduction} />
              </p>
              <div className="icon-circle">
                <span className="fa fa-search" aria-hidden="true" />
              </div>
              <div className="icon-circle">
                <span className="fa fa-cloud-download" aria-hidden="true" />
              </div>
              <div className="icon-circle">
                <span className="fa fa-envelope" aria-hidden="true" />
              </div>
              <div className="spacer small"></div>
              <a type="button" className="btn btn-primary" role="button"
                onClick={this.handleButtonClick} data-qa-item="viewHealthInfoButton"
                tabIndex={0}
                aria-label={ formatMessage(messages.screenReader.button) }
              >
                <FormattedMessage {...messages.panel.buttonText} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HealthSummaryDashboardPanel.propTypes = {
  capabilities: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  externalSystems: PropTypes.array,
  patientId: PropTypes.number,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  capabilities: state.capability.capabilities,
  externalSystems: state.externalSystems.externalSystems,
  patientId: state.profile.patient.patientId,
});

export default connect(mapStateToProps)(injectIntl(HealthSummaryDashboardPanel));